import { Buffer } from 'buffer'

export const fromBase64 = (base64?: string) => {
  return base64 ? Buffer.from(base64, 'base64').toString('utf-8') : undefined
}

export const toBase64 = (value?: string) => {
  return value ? Buffer.from(value, 'utf-8').toString('base64') : undefined
}
